export default {
  title: 'รางวัล',
  points_balance: 'คะแนนสะสม',
  lifetime_earned: 'คะแนนที่ได้รับทั้งหมด',
  lifetime_redeemed: 'คะแนนที่แลกทั้งหมด',
  points_unit: 'คะแนน',
  my_qr: 'QR ของฉัน',
  view_catalog: 'แลกของรางวัล',
  view_history: 'ประวัติการแลก',
  no_coupons: 'ยังไม่มีแคมเปญที่ใช้งานอยู่',
  no_coupons_sub: 'สะสมคะแนนโดยให้ร้านค้าพันธมิตรสแกน QR ของคุณ',
  campaign_qr: 'สแกนเพื่อรับคะแนน',
  qr_expires_in: 'รีเฟรชใน {{seconds}} วิ',
  qr_refreshing: 'กำลังรีเฟรช...',
  select_campaign: 'เลือกแคมเปญ',
  catalog_title: 'แลกของรางวัล',
  no_catalog: 'ยังไม่มีของรางวัลในขณะนี้',
  cost_points: '{{points}} คะแนน',
  thb_value: '฿{{amount}}',
  out_of_stock: 'หมดสต็อก',
  not_enough_points: 'คะแนนไม่เพียงพอ',
  redeem_button: 'แลกรางวัล',
  redeem_confirm_title: 'ยืนยันการแลกรางวัล',
  redeem_confirm_body: 'แลก "{{name}}" ด้วย {{points}} คะแนน?',
  redeem_success_title: 'แลกสำเร็จ!',
  redeem_success_body: 'แลกรางวัล "{{name}}" เรียบร้อยแล้ว',
  fulfillment_ref: 'เลขอ้างอิง: {{ref}}',
  history_title: 'ประวัติการแลก',
  no_history: 'ยังไม่มีการแลกรางวัล',
  history_points: '-{{points}} คะแนน',
  consent_title: 'เข้าร่วมโปรแกรมสิทธิพิเศษ',
  consent_body:
    'เมื่อเข้าร่วม FlowRent จะแชร์เฉพาะข้อมูลที่เข้ารหัส (ไม่สามารถระบุตัวตน) ข้ามเครือข่ายอสังหาริมทรัพย์ เพื่อมอบสิทธิ์สำหรับผู้เช่าที่ต่อสัญญา ไม่มีการแชร์ข้อมูลส่วนตัวกับบุคคลภายนอก',
  consent_data_shared: 'แชร์เฉพาะข้อมูลที่เข้ารหัส — ไม่มีชื่อ เบอร์โทร หรืออีเมล',
  consent_opt_in: 'ฉันยินยอมและต้องการเข้าร่วม',
  consent_already_registered: 'คุณได้เข้าร่วมโปรแกรมสิทธิพิเศษแล้ว',
  consent_success: 'เข้าร่วมโปรแกรมสิทธิพิเศษสำเร็จ',
  errors: {
    insufficient_points: 'คะแนนของคุณไม่เพียงพอสำหรับรางวัลนี้',
    reward_unavailable: 'รางวัลนี้ไม่พร้อมใช้งานในขณะนี้',
    no_active_lease: 'คุณต้องมีสัญญาเช่าที่ใช้งานอยู่เพื่อแลกรางวัล',
    redeem_failed: 'การแลกรางวัลล้มเหลว กรุณาลองอีกครั้ง',
    consent_failed: 'ไม่สามารถบันทึกความยินยอมได้ กรุณาลองอีกครั้ง',
  },
}
